define('snippet',["jquery", "sidebar"], function($) {
    $(".snippet").each(function(index) {
        var snippet = $(this);
        var html = atob(snippet.data("html"));
        snippet.replaceWith(html);
    });
});
